import { createFileRoute } from '@tanstack/react-router';
import { SetPasswordPage } from '@pages/set-password';

export const Route = createFileRoute('/auth/set-password')({ component: SetPasswordPage });
